import { Fragment, useContext, useMemo } from 'react';
import { ProjectDetailsContext, ProjectStateLoadingContext } from '@/screens/Project.Main/Context';
import { ProjectActionsState } from './ProjectActionsContainer';

type Props = {
  children: React.ReactNode;
};

export const ProjectToolsContainer = (props: Props) => {
  const state = useContext(ProjectDetailsContext);
  const isLoading = useContext(ProjectStateLoadingContext);
  const actionOnParent = useMemo(() => !state.query.data, [state.query.data]);

  if (isLoading) {
    return (
      <Fragment>
        {props.children}
      </Fragment>
    );
  }

  return (
    // <ManageAccessContainer projectId={state.query.data.project?.id}>
    <ProjectActionsState
      actionOnParent={actionOnParent}
      capabilities={state.query.data.capabilities}
      object={state.query.data.object}
      // parent={state.query.data.project.parentId}
      project={state.query.data.project}>
      {props.children}
    </ProjectActionsState>
    // </ManageAccessContainer>
  );
};

ProjectToolsContainer.displayName = 'Project.Tools.Container';